import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/stefan-boltzmann-calculator',
  component: () => import('../../routes/StefanBoltzmannCalculator.svelte'),
  card: {
    id: 'stefan-boltzmann-calculator',
    title: 'Stefan-Boltzmann / Blackbody Radiation Calculator',
    description:
      "Calculate the thermal radiation emitted by any surface using P = ε·σ·A·T⁴. Solves for power, temperature, area, or emissivity, plus Wien's displacement law (λ_max = b/T). Includes 18 emissivity presets and 8 real-world scenarios (Sun, Earth, human body, light bulb, wood stove).",
    icon: 'local_fire_department',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/stefan-boltzmann-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: "Stefan-Boltzmann Calculator – Blackbody Radiation & Wien's Displacement Law",
    description:
      "Free Stefan-Boltzmann calculator: solve P = ε·σ·A·T⁴ for power, temperature, area, or emissivity. Includes Wien's displacement law (λ_max = b/T) with 18 emissivity presets (skin, brick, aluminum, water, soot) and 8 real-world scenarios (Sun, Earth, human body, light bulb). Used in HVAC, astrophysics, materials science, and physiology.",
  },
};

export default meta;
